module.exports = girder_plugin_slicer_cli_web;


//////////////////
// WEBPACK FOOTER
// external "girder_plugin_slicer_cli_web"
// module id = 25
// module chunks = 0